import { useMemo } from "react";

import {
  ConfigurationAttributeResult,
  ConfigurationObjectResult,
} from "@plansoft-configuration-renderer/configuration-api";

export function useSubstructureDisplayAttribute(
  configurations: Array<ConfigurationObjectResult> | null | undefined,
  displayedValueAttributeId: string | undefined,
): ConfigurationAttributeResult | null {
  return useMemo(() => {
    if (!displayedValueAttributeId || !configurations?.[0]?.attributes) {
      return null;
    }
    return (
      configurations[0].attributes.find(
        (a) => a.id === displayedValueAttributeId,
      ) ?? null
    );
  }, [configurations, displayedValueAttributeId]);
}
